import { render, staticRenderFns } from "./ComFooter.vue?vue&type=template&id=48e42cc0&scoped=true"
import script from "./ComFooter.vue?vue&type=script&lang=js"
export * from "./ComFooter.vue?vue&type=script&lang=js"
import style0 from "./ComFooter.vue?vue&type=style&index=0&id=48e42cc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e42cc0",
  null
  
)

export default component.exports